'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tfForm', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: "\n            <div class=\"tf-form\">\n                <div class=\"tf-form-inner\" ng-transclude></div>               \n            </div>\n        "
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tf-form/tf-form.js
// module id = 3012
// module chunks = 13